import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LinearProgress from "@mui/material/LinearProgress";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Snackbar from "@mui/material/Snackbar";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { FieldArray } from "formik";
import { Form, useForm } from "formik-redux";
import isEmpty from "lodash/isEmpty";

import useTranslate from "../../../hooks/use-translate.hook";
import { actions as opportunityActions, selectors as opportunitySelectors } from "../../../opportunity";
import { flex } from "../../../core";
import ConfigHeader from "../../config-header.component";
import { saveSchedulingTypes } from "./schedules-type.actions";
import { SCHEDULING_TYPES_FORM } from "./schedules-type.constants";
import SchedulingTypeList from "./scheduling-type-list.component";

const SchedulingType = () => {
    const dispatch = useDispatch();

    const t = useTranslate();

    const loading = useSelector( opportunitySelectors.isLoadingSchedulingTypes );
    const schedulingTypes = useSelector( opportunitySelectors.getSchedulingTypes );

    const [ showErrors, setShowErrors ] = useState( false );
    const closeErrors = () => setShowErrors( false );

    const formik = useForm({
        form: SCHEDULING_TYPES_FORM,
        enableReinitialize: true,
        initialValues: {
            schedulingTypes: schedulingTypes || [],
        },
        onSubmit: values => dispatch( saveSchedulingTypes( values ) ),
        validate: values => {
            const errors = {};
            errors.schedulingTypes = [];
            values.schedulingTypes.forEach( ( schedulingType, index ) => {
                const error = {};
                if ( !schedulingType.name ) {
                    error.name = "common:validation.required";
                }
                if ( !isEmpty( error ) ) {
                    errors.schedulingTypes[ index ] = error;
                }
            });
            if ( isEmpty( errors.schedulingTypes ) ) {
                delete errors.schedulingTypes;
            }
            return errors;
        }
    });

    const handleAdd = () => formik.setFieldValue( "schedulingTypes", [ ...formik.values.schedulingTypes, {}] );

    useEffect( () => {
        dispatch( opportunityActions.fetchSchedulingTypes() );
    }, [ dispatch ] );
    useEffect( () => {
        if ( formik.error ) {
            setShowErrors( true );
        }
    }, [ formik.error ] );

    return (
        <div>
            <Snackbar
                open={ showErrors }
                action={ <Button onClick={ closeErrors } color="secondary">{ "OK" }</Button>}
                message={ formik.error }
                autoHideDuration={ 5000 }
                onClose={ closeErrors }
            />
            <ConfigHeader
                title={ t( "config:opportunity-scheduling-types.title" ) }
                actionTitle={ t( "config:opportunity-scheduling-types.add" ) }
                actionIcon={ AddIcon }
                disabled={ formik.submitting }
                onActionClick={ handleAdd }
            />

            <Card>
                <CardHeader
                    subheader={ t( "config:opportunity-scheduling-types.call-to-action" ) }
                />
                {
                    loading ?
                        <LinearProgress/> :
                        <>
                            <CardContent>
                                <Form formik={ formik }>
                                    <FieldArray
                                        name="schedulingTypes"
                                        component={ SchedulingTypeList }
                                    />
                                </Form>
                            </CardContent>
                            <CardActions className={ flex.justifyContentEnd }>
                                <Button
                                    color="primary"
                                    onClick={ formik.submitForm }
                                    variant="contained"
                                    disabled={ formik.submitting }
                                >
                                    { t( "common:save" ) }
                                </Button>
                            </CardActions>
                        </>
                }
            </Card>
        </div>
    );
};

export default SchedulingType;